import cn from 'clsx';
import {useTranslation} from 'react-i18next';
import {Guidebook} from '@chekin/core';
import {CustomIcon} from '@guestapp/old-ui-kit';
import {GuidebookIcon} from './GuidebookIcon';

type Props = {
  guidebooks: Guidebook[];
  onItemClick: (guidebook: Guidebook) => void;
};

function GuidebooksList({guidebooks, onItemClick}: Props) {
  const {t} = useTranslation();

  return (
    <div className="guidebook-nav-list flex w-full flex-col rounded-xl bg-boxes-modals-color p-4 shadow-[0_3px_6px_0_rgba(0,0,0,0.07)] mb-4 lg:gap-4 lg:p-6">
      <div className="guidebook-nav-list__header">
        <div className="text-[var(--font-primary)] text-xl font-medium leading-6 tracking-[0.36px] lg:mb-2 lg:text-2xl">
          {t('guidebooks')}
        </div>
        <div className="text-[var(--font-secondary)] text-sm font-normal leading-5">
          {t('guidebooks_description')}
        </div>
      </div>
      <div className="guidebook-nav-list__list">
        {guidebooks.map(guidebook => (
          <div
            className={cn(
              'guidebook-nav-list__item relative grid cursor-pointer grid-cols-[40px_1fr] gap-4 py-4',
              'last:pb-4 [&:not(:last-child)]:border-b [&:not(:last-child)]:border-black/10',
              'lg:items-center lg:grid-cols-[40px_1fr_16px] lg:p-4 lg:last:pb-0',
            )}
            onClick={() => onItemClick(guidebook)}
            key={guidebook.id}
          >
            <div className="guidebook__icon flex h-10 w-10 items-center justify-center rounded-full bg-secondary-color">
              <GuidebookIcon name={guidebook.icon} size={24} color="var(--brand-icons)" />
            </div>
            <div className="guidebook-nav-list__info [&>div]:pr-2">
              <div className="guidebook-nav-list__item-title text-[var(--font-primary)] text-base font-semibold leading-6 lg:text-lg">
                {guidebook.title}
              </div>
              <div className="guidebook__item-description text-[var(--font-secondary)] text-sm font-normal leading-5">
                {guidebook.description}
              </div>
            </div>
            <div className="guidebook-nav-list__arrow-wrapper hidden lg:block">
              <CustomIcon
                name="grayRightArrow"
                size={16}
                className="box-item__next-arrow ml-auto h-4 w-4 [&_path]:stroke-[var(--brand-icons)]"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export {GuidebooksList};
